<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-popover
      placement="bottom"
      trigger="click"
    >
      <template>
        <div
          v-for="site in filterSites"
          :key="site.id"
          class="site-selector"
        >
          <el-checkbox v-model="query.siteIds" :label="site.id">{{site.name}}</el-checkbox>
        </div>
      </template>
      <template #reference>
        <el-button size="small">选择站房</el-button>
      </template>
    </el-popover>

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <section>
      <section
        v-for="data in dataList"
        :key="data.siteId"
        style="float:left;width:440px;height:450px;"
      >
        <related-chart
          :chart-title="data.title"
          :base-data="data.x"
          :related-data="data.y"
        />
      </section>
    </section>
  </template>
</layout-content>
</template>

<script>
import BaseData from '../../../../BaseData'
import unitConverter from '../../../../../utils/unitConverter'
import RelatedChart from '../../../../../components/Data/RelatedChart'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'

export default {
  name: 'VOCsNOxRelatedChart',
  routeInfo: {
    label: 'VOCs与NOx相关性',
    icon: 'fa fa-users'
  },
  extends: BaseData,
  components: {DataTimeQuery, RelatedChart},
  data () {
    return {
      query: {
        siteIds: [],
        factorIds: [],
        dataType: 60,
        isFuse: false,
        isMultipleIntegral: true,
        isGetInvalidData: true,
        isAuditCompleted: false // finished
      },
      unitProp: 'displayUnit',
      dataList: []
    }
  },
  computed: {
    siteDeviceCategory: () => process.env.ALL_VOCS_DEVICE_CATEGORY | process.env.NO_DEVICE_CATEGORY,
    filterSites () {
      return this.sites.reduce((list, site) => {
        let siteDevices = site.siteDevices.filter(siteDevice => siteDevice.siteDeviceFactors.length > 0)

        if (siteDevices.length > 0) {
          list.push({
            id: site.id,
            name: site.name,
            siteDevices
          })
        }

        return list
      }, [])
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    filterFactors () {
      return this.factors.filter(({id, rootFactorId}) => rootFactorId === 'VOC' || id === '1004')
    },
    canNotSearch () {
      let {query} = this
      return query.siteIds.length === 0 || query.factorIds.length === 0
    },
    vocsFactor () {
      let {filterFactors} = this
      let vocFactor = filterFactors.find(factor => factor.rootFactorId === 'VOC')
      return {
        id: 'VOCs',
        name: 'VOCs',
        stdUnit: vocFactor.stdUnit,
        displayUnit: vocFactor.displayUnit,
        decimalNum: vocFactor.decimalNum
      }
    },
    noxFactor () {
      return this.filterFactors.find(factor => factor.id === '1004')
    }
  },
  methods: {
    onAuditCompletedChanged () {
      let {query} = this
      query.isAuditCompleted ? query.isGetInvalidData = false : query.isGetInvalidData = true
      if (query.isAuditCompleted === 'isFuse') {
        query.isFuse = true
        delete query.isAuditCompleted
      } else {
        query.isFuse = false
      }
      this.getData()
    },
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false
    //   this.getData()
    // },
    onSitesChanged () {
      let {filterSites, query, filterFactors} = this
      let {siteIds} = query

      if (filterSites.length > 0 && siteIds.length === 0) {
        siteIds.push(filterSites[0].id)
      }

      if (filterFactors.length > 0 && query.factorIds.length === 0) {
        query.factorIds = filterFactors.map(factor => factor.id)
      }

      if (!this.canNotSearch) {
        this.getData()
      }
    },
    getData () {
      let {query} = this
      this.currentQuery = JSON.parse(JSON.stringify(query))
      this.changeLoadStatus(true)
      this.$api.Data.getHistoryData(query).then(dataList => {
        this.tmpList = dataList
        this.formatData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData () {
      let {currentQuery, filterSiteMap, tmpList, unitProp, factorMap, vocsFactor, noxFactor} = this
      let {siteIds, dataType} = currentQuery
      let beginTimeTS = new Date(currentQuery.beginTime).getTime()
      let endTimeTS = new Date(currentQuery.endTime).getTime()
      let timeStep = dataType * 60000
      let dataTimes = []

      for (let ts = beginTimeTS; ts <= endTimeTS; ts += timeStep) {
        dataTimes.push(new Date(ts).format('YYYY/MM/DD HH:00:00'))
      }

      let dataMap = siteIds.reduce((map, siteId) => {
        let cloneVOCsFactor = JSON.parse(JSON.stringify(vocsFactor))
        let cloneNOxFactor = JSON.parse(JSON.stringify(noxFactor))

        cloneVOCsFactor.unit = cloneVOCsFactor[unitProp]
        cloneNOxFactor.unit = cloneNOxFactor[unitProp]

        cloneVOCsFactor.data = dataTimes.reduce((map, dataTime) => {
          map[dataTime] = {
            dataTime,
            value: NaN,
            isHaveIntegral: false
          }
          return map
        }, {})

        cloneNOxFactor.data = dataTimes.reduce((map, dataTime) => {
          map[dataTime] = {
            dataTime,
            value: NaN
          }
          return map
        }, {})

        map[siteId] = {
          siteId,
          title: filterSiteMap[siteId].name,
          x: cloneVOCsFactor,
          y: cloneNOxFactor
        }

        return map
      }, {})

      const queryIsAuditCompleted = currentQuery.isAuditCompleted
      const auditType = (queryIsAuditCompleted + 1) | (-currentQuery.isFuse & 3)

      tmpList.forEach(data => {
        let siteData = dataMap[data.siteId]

        if (!siteData) {
          return
        }

        let {factorId} = data
        let factor = factorMap[factorId]
        let {stdUnit, molecular, decimalNum} = factor
        let value = Number(unitConverter(data.value, stdUnit, factor[unitProp], molecular).toFixed(decimalNum))

        if (factor.rootFactorId === 'VOC') {
          let valueMap = siteData.x.data[data.dataTime]

          if (Number.isNaN(valueMap.value)) {
            valueMap.value = 0
          }

          if (data.isHaveIntegral) {
            valueMap.isHaveIntegral = data.isHaveIntegral
          }
          valueMap.value += value
        } else {
          const yData = siteData.y.data[data.dataTime]
          const isHaveIntegral = yData.isHaveIntegral = data.isHaveIntegral

          const displayFlags = []

          const bin = auditType & (data.isAuditCompleted + 1)

          if (queryIsAuditCompleted === false || bin === 1) {
            if (isHaveIntegral) {
              displayFlags.push('')
            } else {
              displayFlags.push(data.dasFlag)
            }
          } else if (bin === 2) {
            const {value} = data

            if (value) {
              const {auditFlag} = data

              if (auditFlag) {
                displayFlags.push(auditFlag === 'DELETE' ? 'O' : 'R', data.auditComment)
              }
            } else {
              displayFlags.push(data.auditComment)
            }
          }

          yData.value = value
          yData.displayFlags = displayFlags
        }
      })

      let vocDecimalNum = vocsFactor.decimalNum

      this.dataList = Object.freeze(Object.values(dataMap).map(data => {
        let vocsFactor = data.x
        vocsFactor.data = Object.values(vocsFactor.data)
        let isHaveIntegral = false

        vocsFactor.data.forEach(data => {
          let value = data.value

          if (data.isHaveIntegral) {
            isHaveIntegral = true
          }

          if (Number.isFinite(value)) {
            data.value = Number(value.toFixed(vocDecimalNum))
          }
        })

        let noxFactor = data.y
        noxFactor.data = Object.values(noxFactor.data)

        return {
          siteId: data.siteId,
          title: data.title,
          isHaveIntegral: isHaveIntegral,
          x: vocsFactor,
          y: noxFactor
        }
      }))
    },
    onSearchBtnClick () {
      this.getData()
    },
    onUnitPropChange () {
      this.formatData()
    }
  }
}
</script>

<style lang="scss" scoped>
.site-selector {
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/03Sensitivity/01VOCs-NOx-Related/index.vue